<!-- TODO: Multilang -->
<template>
  <v-dialog v-if="showModalDialog"
    v-model="showModalDialog"
    persistent
    refs="modalDialog"
    @keydown.esc="close"
    :content-class="'qmkey-modal-dialog '+(small ? 'qmkey-small-dialog' : '')"
  >
    <div
      class="modal-card"
      :class="dialog_class"
    >

      <div class="fc-centro-modal" v-if="centros.length >1">
          <div class="fc-centro-img-cont-modal">
            <img class="fc-centro-img-modal" :src="centro_logo(current_centro)" @error="failed_logo(centro_id)" />
          </div>
          <!-- <div class="fc-centro-indent" :style="indent_style(centro)"></div> -->
          <div class="fc-centro-name-modal">{{ current_centro.name }}</div>
      </div>
      <div class="modal-card-close" @click="close">
        <v-icon>mdi-close</v-icon>
      </div>
    
      <div class="fc-modal-card-title">
        <div class="qmkey-modal-h1 pb-0">
          {{ title }}
        </div>
      </div>

      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <v-divider v-if="!loading" class="modal-card-title-divider"></v-divider>

      <v-card-subtitle> </v-card-subtitle>

      <div class="pb-2">
        <slot
          name="modal_content"
        >
          <DynamicForm
            :fields="fields_to_collect"
            :unit="unit"
            ref="dynamicForm"
            @ready="isReady => valid = isReady"
            :return_object="return_object"
          />
          <div class="text-block">
            <pre>{{ message }}</pre>
          </div>
        </slot>
      </div>

      <div class="modal-card-actions">
        <v-btn 
          class="qmkey-modal-dialog-button-secondary"
          :class="is_mobile ? 'small-modal-button' : ''"
          @click="clear"
          v-if="!hide_clear_button"
        > 
          {{clear_button_label}}
        </v-btn>

        <v-btn
          class="qmkey-modal-dialog-button-submit"
          :class="is_mobile ? 'small-modal-button' : ''"
          @click.prevent="perform_action"
          :disabled="loading || !valid && validate"
          :loading="loading"
        >
          {{submit_button_label}}
        </v-btn>

        <slot name="bottom"></slot>
      </div>
    </div>
  </v-dialog>
</template>


<style lang="scss">
 @import '@/sass/modalform.scss';

 .fc-list-modal {
   width: 100%;
   display: flex;
   flex-direction: column;
   overflow-x: hidden;
   overflow-y: hidden;
   max-height: 50vh;
   max-width: 70vw;
   cursor: default;
   font-family: Roboto,sans-serif;
 }

 .fc-centro-modal {
   display: flex;
   flex-direction: row;
   align-items: center;
   height: 42px;
   padding: 4px 0px 4px 8px;
   position: absolute;
   top: 0em;
 }

 .fc-centro-img-cont-modal {
   height: 100%;
   width: 64px;
   display: flex;
   align-items: center;
   justify-content: center;
 }

 .fc-centro-img-modal {
   height: 100%;
   width: 100%;
   object-fit: contain;
 }

 .fc-centro-name-modal {
   padding-left: 8px;
   width: 95%;
 }

 .fc-modal-card-title-modal {
  margin-top: 10px;
 }

</style>


<script>
 import { mapGetters, mapState } from 'vuex'
 import { resolve_logo } from '@/utils/logos';


 export default {
   name: 'ModalDialogForm',
   components: {
     DynamicForm: () => import('@/components/DynamicForm'),
   },
   props: {
     title: String,
     showModalDialog: Boolean,
     fields_to_collect: {type: Array, default: () => ([])}, 
     submit_button_text: String,
     clear_button_text: String,
     message: String,
     unit: Object,
     small: Boolean,
     validate: Boolean,
     dialog_class: String,
     loading: {type: Boolean, default: false},
     return_object: {type: Boolean, default: false},
     hide_clear_button: {type: Boolean, default: false},
   },
   data() {
     return {
       valid: null,
       disable: false,
       alert: false,
       err: '',
       logofails: [], // [centro_id]
     }
   },

   computed: {    
    ...mapState(['is_mobile', 'site_centros']),
    ...mapGetters(['centro_id', 'site_id']),
     submit_button_label() {
       // TODO:lang
       return this.submit_button_text || this.$vuetify.lang.translator('dialog.save');
     },
     clear_button_label() {
       // TODO:lang
       return this.clear_button_text || this.$vuetify.lang.translator('dialog.clear');
     },
     centros() {
       return this.site_centros[this.site_id];
     },

     current_centro() {
      return this.site_centros[this.site_id].find(obj => {
        return obj.id == this.centro_id
      })
     },
     logofails_set() {
       return new Set(this.logofails);
     },
   },
   
   methods: {
     clear() {
       this.$emit('clear');
       this.local_clear();
       //this.alert = false
       // this.$refs.dynamicForm.clear();
     },
     close() {
       this.local_clear();
      //  this.valid = null;
      //  this.disable = false;
       this.$emit("close-dialog", '');
     },
     perform_action: function(evt) {
       evt.preventDefault()
       let creation_form = new FormData();
       if(this.$refs.dynamicForm) {
        creation_form = this.$refs.dynamicForm.get_data();
       }
       this.$emit("submit", creation_form)
       
     },
     local_clear() {
       this.alert = false
       if (this.$refs.dynamicForm) {
        try {
          // FIXME:
          this.$refs.dynamicForm.clear();
        }catch (error) {
          console.error("Error", error)
        }
       }
     },
     centro_logo(centro) {
       const failed = this.logofails_set.has(centro.id);
       return resolve_logo(centro.logo, failed);
     },

     failed_logo(centro) {
      if (centro) {
        console.error('Error: loading centro logo \''+centro.name+' ('+centro.id+')\'');
        this.logofails.push(centro.id);
      } else {
        console.error('Error: couldn\'t load logo, there is no centro');
      }
     },
   },
  //  watch: {
  //    enable_button: function() {
  //      if (this.$refs.dynamicForm){
  //        this.valid = this.$refs.dynamicForm.form
  //      }
  //      this.valid = false
  //    }
  //  },
 }
</script>
